import { Stack, Text, SimpleGrid } from '@mantine/core';
import type { PfileRow } from '@lib2/model/pfile/PfileTypes';
import { createPfileIds } from '@lib2/model/pfile/PfileUtil';
import { PfileImageUploader } from '@/shared/components/PfileImageUploader';
import type { PfileImageSpec } from '@/lib/constants/pfileImage';
import { APP_WEB_IMAGE_SPECS_WITH_HOOKS } from '../webLogoSpec';
import { APP_QUERY_KEYS } from '@/lib/constants/app';

interface AppImagesTabProps {
  appCfgId: number;
  cId: number;
  pfiles: PfileRow[];
  title?: string;
  description?: string;
  specs?: PfileImageSpec[];
}

export function AppImagesTab({
  appCfgId,
  cId,
  pfiles,
  title = 'Web App Images',
  description = 'Upload images for your web application. All images are processed to WebP format.',
  // the Logo slot carries the fit-and-pad hooks (plan 2.7); the other slots are the plain constants
  specs = APP_WEB_IMAGE_SPECS_WITH_HOOKS,
}: AppImagesTabProps) {
  const invalidateQueryKeys = [
    APP_QUERY_KEYS.detail(cId, appCfgId),
    APP_QUERY_KEYS.list(cId),
  ];

  return (
    <Stack gap="lg">
      <Text fw={600} size="lg">{title}</Text>
      <Text size="sm" c="dimmed">
        {description}
      </Text>

      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="xl">
        {specs.map((spec) => (
          <PfileImageUploader
            key={spec.pfileTypeId}
            pfiles={pfiles}
            spec={spec}
            pfileIds={createPfileIds({
              appCfgId,
              pfileTypeId: spec.pfileTypeId,
            })}
            invalidateQueryKeys={invalidateQueryKeys}
            containerHeight={200}
          />
        ))}
      </SimpleGrid>
    </Stack>
  );
}
